import { createClient } from '@supabase/supabase-js';

// Growth Hub Supabase connection (shared database for tracking & content)
const GROWTH_HUB_URL = 'https://xvcoghpmuaetdiyzoliy.supabase.co';

// Growth Hub anon key (publishable - safe to include as fallback)
export const GROWTH_HUB_ANON_KEY = import.meta.env.VITE_GROWTH_HUB_ANON_KEY || 
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inh2Y29naHBtdWFldGRpeXpvbGl5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM5NDk1OTgsImV4cCI6MjA3OTUyNTU5OH0.ruKqbFJQU6NEwTcxqqzAPSUI6jma29gnC5DcKuPWcLQ';

export const growthHubSupabase = createClient(GROWTH_HUB_URL, GROWTH_HUB_ANON_KEY);

// Edge function URLs
export const GROWTH_HUB_FUNCTIONS = {
  trackerScript: `${GROWTH_HUB_URL}/functions/v1/serve-tracker-script`,
  visitorTracking: `${GROWTH_HUB_URL}/functions/v1/visitor-tracking`,
  metaConversionsApi: `${GROWTH_HUB_URL}/functions/v1/meta-conversions-api`,
  visualizerTracking: `${GROWTH_HUB_URL}/functions/v1/visualizer-tracking`,
  // SEO Data Sync endpoints
  seoDataReceiver: `${GROWTH_HUB_URL}/functions/v1/receive-seo-data`,
  citationAudit: `${GROWTH_HUB_URL}/functions/v1/citation-audit`,
  rankingSync: `${GROWTH_HUB_URL}/functions/v1/ranking-sync`,
};

// Tracking ingestion MUST go to Growth Hub (xvcoghpmuaetdiyzoliy),
// not the website's own backend. The website's local Supabase has no
// visitor_sessions / page_events tables.
export const LOCAL_FUNCTIONS = {
  serverSideTracking: `${GROWTH_HUB_URL}/functions/v1/server-side-tracking`,
  identifyVisitor: `${GROWTH_HUB_URL}/functions/v1/identify-visitor`,
  visitorTracking: `${GROWTH_HUB_URL}/functions/v1/visitor-tracking`,
};

export const TRACKING_HEADERS: Record<string, string> = {
  'Content-Type': 'application/json',
  'apikey': GROWTH_HUB_ANON_KEY,
  'Authorization': `Bearer ${GROWTH_HUB_ANON_KEY}`,
};

// Growth Hub is always configured since we have a hardcoded fallback key
export const isGrowthHubConfigured = () => {
  return true;
};
